import React from "react";
import "./CustomSwitch.scss";
import "./Adaptations.scss";
import ActiveImg from "../../static/img/map_img/ActiveSwitch.svg";

export default function CustomSwitch({ activeState, onClick }) {
    return (
        <>
            <div
                className="custom-switch"
                role="switch"
                aria-checked={activeState}
                onClick={onClick}
            >
                <img
                    className={`active-img ${activeState ? "visible" : ""}`}
                    src={ActiveImg}
                    alt="Active"
                />
                <div
                    className={`switch-handle ${activeState ? "active" : ""}`}
                />
            </div>
        </>
    );
}
